<app-profile-header></app-profile-header>
<section class="body-section">
    <div class="container">
        <main>

            <div class="col-md-12 user-top-body-header d-flex justify-content-between">
                <div class="right-side-section">
                    <div class="box spending-box">
                        <div class="not-found-section d-none">
                            <div class="col-md-12 not-found-body  "><img src="assets/img/logo/not-found.gif" alt="">
                                <h4>Coming Soon!</h4>
                                <p>Exciting developments are on the horizon! Keep an eye out for an impending
                                    announcement that will have you excited and anticipating what's to come. We can't
                                    wait to tell you about this fantastic news. Keep a look out for additional updates,
                                    because something fantastic is on the way!</p>
                            </div>
                        </div>
                        <div class="pie-chart ">
                            <p-chart type="doughnut" [data]="data" [options]="options"></p-chart>
                            <div class="overall-spending">
                                <h4>skill
                                </h4>
                                <span>{{playerRating}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-container Transaction-table MatchesHistory ">
                <div class="box transaction-box">
                    <div class="header-container">
                        <h3 class="section-header">Matches History
                        </h3>
                    </div>
                    <p-table class=" expandable" #dt [value]="matchList" [paginator]="true" [rows]="10" [lazy]="true"
                        [scrollable]="true" scrollHeight="auto" scrollDirection="both" #paginator pageLinks="3" [showPageLinks]="true"
                        [totalRecords]="totalRecords" (onLazyLoad)="loadMatches($event)" [loading]="loading"
                        [rowsPerPageOptions]="paginationOption">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th class="name-td">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Name
                                    </div>
                                </th>
                                <th class="myskillTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        My Skills
                                    </div>
                                </th>
                                <th class="skillTD ">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Opponent
                                    </div>
                                </th>
                                <th class="matchesTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Op. Skill

                                    </div>
                                </th>
                                <th class="tournament-head">
                                    <div class="p-d-flex p-jc-between p-ai-center ">
                                        Tournaments
                                    </div>
                                </th>
                                <th class="tournament-result tournamentresultTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Result

                                    </div>
                                </th>

                                <th class="dateTD">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Date
                                    </div>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-match>
                            <tr class="p-selectable-row">
                                <td class="name-td">
                                    <div class="mobile-heading">
                                        Name
                                    </div>
                                    {{this.item?.fullName}}
                                </td>
                                <td *ngIf="match?.opponents_data?.myRating?.showclass" class="myskillTD">
                                    <div class="mobile-heading">
                                        My Skills
                                    </div>
                                    {{match?.opponents_data?.myRating?.winnerRating}}
                                    {{match?.opponents_data?.myRating?.looserRating}}
                                    <span *ngIf="match?.opponents_data?.myRating?.showclass" class="colorgreen">&nbsp;+{{match?.opponents_data?.myRating?.difference}}
                                    </span>
                                    <span *ngIf="!match?.opponents_data?.myRating?.showclass" class="colorred">
                                        &nbsp;{{match?.opponents_data?.myRating?.difference}}
                                    </span>
                                </td>
                                <td *ngIf="!match?.opponents_data?.myRating?.showclass" class=" myskillTD ">
                                    <div class="mobile-heading">
                                        My Skills
                                    </div>
                                    {{match?.opponents_data?.myRating?.winnerRating}}
                                    {{match?.opponents_data?.myRating?.looserRating}}
                                    <span *ngIf="match?.opponents_data?.myRating?.showclass" class="colorgreen">&nbsp; + {{match?.opponents_data?.myRating?.difference}}
                                    </span>
                                    <span *ngIf="!match?.opponents_data?.myRating?.showclass" class="colorred">
                                        &nbsp;{{match?.opponents_data?.myRating?.difference}}
                                    </span>
                                </td>
                                <td class="skillTD">
                                    <div class="mobile-heading">
                                        Opponent
                                    </div>
                                    {{match?.opponents_data?.userData?.fullName}}
                                </td>
                                <td class="matchesTD">
                                    <div class="mobile-heading">
                                        Op. Skill.
                                    </div>
                                    {{match?.opponents_data?.opponentRating?.winnerRating}}
                                    {{match?.opponents_data?.opponentRating?.looserRating}}
                                </td>
                                <td class="tournament-head tournamentTD">
                                    <div class="mobile-heading">
                                        Tournaments
                                    </div>
                                    <div class="tournament-name" tooltipPosition="bottom"
                                        pTooltip="{{match.opponents_data?.matchName}} {{match.opponents_data?.ageGroupName}} {{match.opponents_data?.tournamentData[0]?.name}}">
                                        {{match.opponents_data?.matchName}}
                                        {{match.opponents_data?.ageGroupName}}
                                        {{match.opponents_data?.tournamentData[0]?.name}}
                                    </div>

                                </td>
                                <td class="tournament-result tournamentresultTD">
                                    <div class="mobile-heading">
                                        Result
                                    </div>
                                    <span
                                        class="rin-type-label score">{{match.opponents_data?.player1val}} - {{match.opponents_data?.player2val}}</span>{{match?.opponents_data?.playerScore}}
                                </td>
                                <td class="dateTD">
                                    <span class="mobiledate">Date : </span>
                                    {{match?.opponents_data?.tournamentData[0]?.startdate|date:'dd-MM-yyyy'}}
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="7" class="not-found-massage-div">
                                    <div class="not-found-section w-100" style="border:none;">
                                        <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif" alt="">
                                            <h4> Match History not found!</h4>
                                            <p>You haven't participated in any tournaments.</p>
                                        </div>
                                    </div>


                                </td>
                            </tr>
                        </ng-template>

                    </p-table>
                </div>
            </div>
            <div class="bottom-container Transaction-table  d-none">
                <div class="box transaction-box ">
                    <div class="header-container">
                        <h3 class="section-header">Skill History</h3>
                    </div>
                    <div class="col-md-12 d-flex justify-content-end ">
                        <p-dropdown inputId="yearOptions" [ngModel]="selectedYear" [options]="yearOptions"
                            (onChange)="onClickYear($event)" placeholder="Select year" optionLabel="year"
                            [filter]="true"></p-dropdown>
                    </div>

                    <p-chart type="line" [data]="skillsData" [options]="basicOptions"></p-chart>
                </div>
            </div>
        </main>
    </div>
</section>